import { z } from 'zod'
import { AiGenJobResultSchema } from 'pages/AICreation/AICreationFlow/api'
import { CartUpsellOfferBaseSchema } from '../cartUpsellRecord.schemas'

const AiWallOfferBaseSchema = CartUpsellOfferBaseSchema.extend({
  jobId: z.string(),
  results: z.array(AiGenJobResultSchema.pick({ url: true, preview: true })),
  // The job's result size, passed to uploadPhotos so it doesn't load each image to measure it.
  width: z.number(),
  height: z.number(),
})
export type AiWallOffer = z.infer<typeof AiWallOfferBaseSchema>

export function createAiWallOfferSchema(resultsCount: number) {
  return AiWallOfferBaseSchema.extend({
    results: AiWallOfferBaseSchema.shape.results.length(resultsCount),
  })
}
